module.exports = __webpack_public_path__ + "static/media/apiwiz-logo.b59aa906.png";